export default "__VITE_ASSET__BiDR_yLo__"